import { ReactElement } from 'react'
import styled from 'styled-components'

import LogoPlainGradient from '../../assets/images/logo-plain-gradient.svg'
import Text from '../../components/Text'
import { media } from '../../utils/stringUtils'
import { BREAKPOINT } from '../app/constants'

const StyledLogoPlainGradient = styled(LogoPlainGradient)`
  margin-bottom: 36px;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled(Text)`
  margin-bottom: 20px;
  font-size: 2.8rem;
  line-height: 1.171875em;

  ${media(BREAKPOINT.medium)} {
    font-size: 3.2rem;
  }
`

type AuthStepHeadProps = {
  className?: string
  title: string | ReactElement
}

function AuthStepHead({ className, title }: AuthStepHeadProps) {
  return (
    <Container className={className}>
      <StyledLogoPlainGradient />
      <Title forwardedAs="h1" weight="medium" size="giant" align="center">
        {title}
      </Title>
    </Container>
  )
}

export default AuthStepHead
